var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#189CD8",
    cx: 35,
    cy: 35,
    r: 35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.801,15.76H42.53v-2.182c0-0.401-0.325-0.727-0.727-0.727H27.263c-0.402,0-0.727,0.326-0.727,0.727 v2.182h-7.271c-0.402,0-0.727,0.325-0.727,0.726v40.715c0,0.402,0.325,0.728,0.727,0.728h30.536c0.402,0,0.728-0.325,0.728-0.728 V16.486C50.528,16.085,50.203,15.76,49.801,15.76z M27.99,14.305h13.086v4.362H27.99V14.305z M38.096,21.576h-7.125 c-0.049-0.239-0.073-0.484-0.073-0.728v-0.728h7.27v0.728C38.168,21.092,38.145,21.337,38.096,21.576z M22.9,40.479h23.266v11.632 H22.9V40.479z M46.166,39.025H22.9V28.847h23.266V39.025z M46.166,27.392H22.9v-4.361h7.042c1.199,2.535,4.226,3.619,6.761,2.42 c1.063-0.502,1.919-1.358,2.422-2.42h7.041V27.392z M34.533,24.484c-1.138-0.003-2.208-0.542-2.889-1.454h5.779 C36.742,23.942,35.671,24.481,34.533,24.484z M49.075,56.475H19.992V17.214h6.544v2.181c0,0.402,0.325,0.726,0.727,0.726h2.182 v0.728c0.001,0.244,0.021,0.486,0.058,0.728h-7.329c-0.402,0-0.727,0.326-0.727,0.727v30.536c0,0.402,0.325,0.728,0.727,0.728 h24.72c0.4,0,0.727-0.325,0.727-0.728V22.303c0-0.401-0.326-0.727-0.727-0.727h-7.329c0.037-0.241,0.057-0.484,0.059-0.728v-0.728 h2.181c0.401,0,0.727-0.324,0.727-0.726v-2.181h6.545V56.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.444,15.76h1.454v1.454h-1.454V15.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.168,15.76h1.455v1.454h-1.455V15.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.804,36.116h1.454v1.455h-1.454V36.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M33.08,37.571h1.454c1.205,0,2.182-0.977,2.182-2.181v-2.909c0-1.204-0.977-2.181-2.182-2.181H33.08 c-0.402,0-0.728,0.325-0.728,0.727v5.816C32.352,37.246,32.677,37.571,33.08,37.571z M33.807,31.755h0.727 c0.402,0,0.727,0.325,0.727,0.726v2.909c0,0.401-0.325,0.726-0.727,0.726h-0.727V31.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.896,35.39h2.181v-1.455h-2.181v-2.18h2.181v-1.455h-2.908c-0.401,0-0.727,0.325-0.727,0.727v6.543 h1.454V35.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.717,37.571V35.39h0.364c1.405,0,2.544-1.139,2.544-2.545c0-1.406-1.139-2.544-2.544-2.544H27.99 c-0.401,0-0.727,0.325-0.727,0.727v6.543H28.717z M28.717,31.755h0.364c0.602,0,1.09,0.487,1.09,1.09s-0.488,1.09-1.09,1.09 h-0.364V31.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.354,44.842h20.357v1.454H24.354V44.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.354,41.934h20.357v1.454H24.354V41.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.354,47.75h17.449v1.454H24.354V47.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.258,47.75h1.454v1.454h-1.454V47.75z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformes);
export default __webpack_public_path__ + "static/media/Informes.d1c9ab33c47ad5f3c2f117ca21f78bf2.svg";
export { ForwardRef as ReactComponent };